import type { AuthUser } from "../types/auth";
import { FORM_IDS, PROCESS_IDS } from "./permissionCatalog";
import { hasPermission } from "./permissions";

function isOfficeUser(user: AuthUser | null | undefined): boolean {
  return user?.type === "office";
}

export function canViewContracts(user: AuthUser | null | undefined): boolean {
  return isOfficeUser(user) && hasPermission(user, {
    forms: [FORM_IDS.CONTRACTS],
    processes: [PROCESS_IDS.CONTRACT_VIEW],
  });
}

export function canCreateContracts(user: AuthUser | null | undefined): boolean {
  return isOfficeUser(user) && hasPermission(user, {
    forms: [FORM_IDS.CONTRACTS],
    processes: [PROCESS_IDS.CONTRACT_MANAGE],
  });
}

export function canApproveContracts(user: AuthUser | null | undefined): boolean {
  return isOfficeUser(user) && hasPermission(user, {
    forms: [FORM_IDS.CONTRACTS],
    processes: [PROCESS_IDS.CONTRACT_APPROVE],
  });
}

export function canManageContractApprovalChains(user: AuthUser | null | undefined): boolean {
  return isOfficeUser(user) && hasPermission(user, {
    forms: [FORM_IDS.CONTRACT_CHAINS],
    processes: [PROCESS_IDS.CONTRACT_CHAIN_MANAGE],
  });
}
